import { Quote } from "lucide-react";
import { Reveal, MaskLines } from "@/components/Motion";
import { SectionHead } from "@/components/Common";
import { TESTIMONIALS } from "@/data/site";

// Hidden until real client reviews are added to TESTIMONIALS in site.js.
export const Testimonials = () => {
  if (!TESTIMONIALS.length) return null;
  return (
    <section data-testid="testimonials-section" className="bg-[#14263D] py-24 text-white md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <SectionHead light eyebrow="Client Reviews" title={<MaskLines onView lines={["What Homeowners", "Are Saying"]} />} />
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 3) * 0.1}>
              <figure data-testid={`testimonial-${i}`} className="flex h-full flex-col justify-between rounded-[4px] border border-white/15 bg-white/[0.04] p-8 transition-colors duration-500 hover:bg-white/[0.08]">
                <div>
                  <Quote className="h-7 w-7 text-[#f0b3b7]" aria-hidden="true" />
                  <blockquote className="mt-5 font-display text-2xl leading-snug">{t.quote}</blockquote>
                </div>
                <figcaption className="mt-8 border-t border-white/15 pt-5">
                  <p className="font-semibold">{t.name}</p>
                  {t.location && <p className="mt-1 font-mono text-xs uppercase tracking-[0.2em] text-white/70">{t.location}</p>}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
